import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-clipboard',
  templateUrl: './icon-clipboard.component.html',
  styleUrls: ['./icon-clipboard.component.scss'],
})
export class IconClipboardComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
